module.exports = __webpack_public_path__ + "static/img/Spread-Eagle.752757f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Spread-Eagle.jpg
// module id = kjEd
// module chunks = 0